import { DEFAULT_ROBOT_TEXTS } from '@/services/dataRepo';

/** Texte robot : réglages professeur, sinon valeur par défaut du dépôt (aucune phrase « magique » hors config). */
export function robotTextOrDefault(settings, key) {
  const raw = settings?.robot_texts?.[key];
  const t = raw != null ? String(raw).trim() : '';
  if (t) return t;
  const d = DEFAULT_ROBOT_TEXTS[key];
  return d != null ? String(d).trim() : '';
}

/** Texte robot uniquement si renseigné dans les réglages (chaîne vide = silence). */
export function robotTextOptional(settings, key) {
  const raw = settings?.robot_texts?.[key];
  return raw != null ? String(raw).trim() : '';
}

/** Insère le prénom dans un texte configuré ({prénom} ou {prenom}). */
export function replaceNamePlaceholders(text, childName) {
  const name = String(childName || '').trim();
  return String(text ?? '')
    .replace(/\{prénom\}/gi, name)
    .replace(/\{prenom\}/gi, name);
}

/** Repli legacy si la question identité n’a pas de remerciement (champ name_success des réglages). */
export function robotNameSuccessMessage(settings, childName) {
  return replaceNamePlaceholders(robotTextOrDefault(settings, 'name_success'), childName);
}
